var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolkswagen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.12 10.4a9.836 9.836 0 00-5.024-.01l2.517 6.933L23.12 10.4zM30.501 20.005a9.849 9.849 0 00-.635-3.514L25.152 28.8a9.953 9.953 0 005.333-8.806"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 11.419l-2.912 8h-4.123l-2.922-8.032a10.017 10.017 0 00-2.806 2.4l4.15 10.746 1.52-3.93h3.984l1.51 3.93 4.191-10.885a9.98 9.98 0 00-2.592-2.23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.581 6.752a13.248 13.248 0 1013.243 13.253A13.28 13.28 0 0020.582 6.752zm0 24.805a11.563 11.563 0 1111.563-11.552 11.59 11.59 0 01-11.563 11.552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49 22.72l-2.56 6.645v.203a9.744 9.744 0 002.667.357 9.918 9.918 0 002.502-.314l-.027-.246-2.581-6.645zM10.667 20.005a9.91 9.91 0 005.168 8.694L11.2 16.703a9.802 9.802 0 00-.533 3.301"
  })));
}
export default SvgVolkswagen;